import { useTranslation } from "react-i18next";
import { House3Icon } from "@/shared/icons";
import { EstateSelectTab } from "@/domains/estate/constants/estateSelectTab";

type Props = {
  count: number;
  selectedTab?: EstateSelectTab;
  title?: string;
};

export default function EstateSlotsHeader({ count, selectedTab, title }: Props) {
  const { t } = useTranslation("estate");

  return (
    <div className="flex justify-between items-center shrink-0 h-13">
      <p className="text-15 font-medium text-white/30">
        {selectedTab
          ? t(`estate.slots.info.${selectedTab}`)
          : t("estate.slots.info.placeOfTenants")}
        {title}
      </p>
      <div className="flex items-center">
        <House3Icon size={16} className="text-white/10" />
        <p className="ml-2.5 mr-1 text-12 font-bold uppercase">
          {selectedTab
            ? t(`estate.slots.countInfo.${selectedTab}`)
            : t("estate.slots.countInfo.myEstate")}
        </p>
        <p className="flex justify-center items-center h-5.5 px-1.5 py-[0.44rem] text-12 font-bold bg-white/5 rounded-md">
          {count}
        </p>
      </div>
    </div>
  );
}
